import React from 'react';

type ModalProps = {
    size?: 'default' | 'sm' | 'lg' | 'xl';
    isScrollable?: boolean;
};

export const Modal: React.FunctionComponent<ModalProps> = ({
                                                               size = 'default',
                                                               isScrollable = false,
                                                               children
                                                           }) => {
    const classNames = [
        size === 'sm' && 'modal-sm',
        size === 'lg' && 'modal-lg',
        size === 'xl' && 'modal-xl',
        isScrollable && 'modal-dialog-scrollable',
    ]
        .filter(Boolean)
        .join(' ');
    return (
        <div className="modal fade show"
             tabIndex={-1}
             role="dialog"
             aria-modal="true"
             style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.75)', overflowY: 'auto'}}
        >
            <div className={`modal-dialog ${classNames}`}
            role="document">
                <div className="modal-content">
                    {children}
                </div>
            </div>
        </div>
    );
};